// extracted by mini-css-extract-plugin
export default {"cls1":"kdypN39IcsLk97g9yud5","cls2":"qbBj4kNX60nTZwC5vxh1 kdypN39IcsLk97g9yud5","isTabletDown":"yYB7NLPkk1VIzpZYr8aK"};